/**
 * All printer sdk command interface
 */
import {HexOutput, PsdkConst} from '../../types';
import {Base64} from 'js-base64';
import {ClauseType, CommandClause} from "./command_clause";
import {PVariableKit} from "../../../toolkit";
// import {FastGBK} from "../../../toolkit";
import * as iconv from 'iconv-lite';

export interface Command {

  /**
   * Binary command
   */
  binary(): Uint8Array;

  /**
   * String command
   */
  string(charset?: string): string;

  /**
   * hex command
   */
  hex(output?: HexOutput): string;

  /**
   * base64 command
   */
  base64(): string;
}

export abstract class BasicCommand implements Command {
  abstract binary(): Uint8Array;

  abstract hex(output?: HexOutput): string;

  abstract string(charset?: string): string;

  base64(): string {
    return Base64.fromUint8Array(this.binary())
  }
}

export class DefaultCommand extends BasicCommand {

  private readonly bytes: Uint8Array;

  constructor(
    clauses: Array<CommandClause>,
    variable: Map<string, any>,
  ) {
    super()
    let bytes = [];
    for (const clause of clauses) {
      switch (clause.type) {
        case ClauseType.TEXT:
          const t = PVariableKit.replace(clause.text, variable);

          //# use gbk encoding
          const t_buffer = iconv.encode(t, clause.charset ?? PsdkConst.DEF_CHARSET);
          // const t_buffer = FastGBK.encode(t);
          const t_binary = Array.prototype.slice.call(t_buffer, 0);
          bytes = bytes.concat(t_binary);

          //# use utf8 encoding
          // const t_binary = ByteKit.textToU8A(t)
          // const array = Array.from(t_binary)
          // bytes.push(...array);
          break;
        case ClauseType.NEWLINE:
        case ClauseType.BINARY:
          const b = Array.from(clause.binary ?? PsdkConst.EMPTY_BYTES);
          bytes = bytes.concat(b);
          break;
      }
    }
    this.bytes = new Uint8Array(bytes);
  }

  binary(): Uint8Array {
    return this.bytes;
  }

  hex(output?: HexOutput): string {
    return (output ?? HexOutput.def()).format(this.binary());
  }

  string(charset?: string): string {
    const buffer = Array.from(this.binary());
    // @ts-ignore
    return iconv.decode(buffer, charset ?? PsdkConst.DEF_CHARSET);
    // return FastGBK.decode(this.binary());
  }

}
